module.exports = {
  UNUSED: 'unused',
  FINE_SCRATCHES: 'fine-scratches',
  VISIBLE_DAMAGE: 'visible-damage',
};
